import PropTypes from 'prop-types';

export const RoutePropType = PropTypes.shape({
  id: PropTypes.number,
  sourceLocationName: PropTypes.string,
  destinationLocationName: PropTypes.string,
});

export const DateRangePropType = PropTypes.shape({
  id: PropTypes.number,
  dateFrom: PropTypes.number,
  dateUntil: PropTypes.number,
});

export const ServiceTypePropType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  description: PropTypes.string,
  lastUpdate: PropTypes.number,
  createDate: PropTypes.number,
});

export const CustomerPropType = PropTypes.shape({
  id: PropTypes.number,
  fullName: PropTypes.string,
});

export const DiscountCodeCategoryPropType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
});

export const AuthorizerUserPropType = PropTypes.shape({
  id: PropTypes.number,
  username: PropTypes.string,
  fullName: PropTypes.string,
});

export const AgencyContractTypeDiscountCodePropType = PropTypes.shape({
  id: PropTypes.number,
  contractType: PropTypes.string,
  discountCodeId: PropTypes.number,
});

export const DiscountCodeTripRulePropType = PropTypes.shape({
  id: PropTypes.number,
  discountCodeId: PropTypes.number,
  serviceTypeId: PropTypes.number,
  serviceType: ServiceTypePropType,
  discountFloorRule: PropTypes.string,
});

export const DiscountCodeDtoPropType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  description: PropTypes.string,
  code: PropTypes.string,
  discount: PropTypes.number,
  discountType: PropTypes.string,
  maxAmount: PropTypes.number,
  isValid: PropTypes.bool,
  maxNumberOfUses: PropTypes.number,
  numberOfUses: PropTypes.number,
  productType: PropTypes.string,
  serviceTypeId: PropTypes.number,
  validFrom: PropTypes.number,
  validUntil: PropTypes.number,
  lastUpdate: PropTypes.number,
  createDate: PropTypes.number,
  includedRouteSet: PropTypes.arrayOf(RoutePropType),
  excludedRouteSet: PropTypes.arrayOf(RoutePropType),
  customerSet: PropTypes.arrayOf(CustomerPropType),
  excludedDateRangeSet: PropTypes.arrayOf(DateRangePropType),
  serviceType: ServiceTypePropType,
  agencyContractTypeDiscountCodeSet: PropTypes.arrayOf(
    AgencyContractTypeDiscountCodePropType,
  ),
  discountCodeTripRuleList: PropTypes.arrayOf(DiscountCodeTripRulePropType),
  discountCodeCategory: DiscountCodeCategoryPropType,
  authorizerUser: AuthorizerUserPropType,
});
